<template>
    <v-container fluid>
        <v-row
            justify="center"
        >
            
            <v-col class="px-0">        
                <v-card
                    class="mx-auto pa-0 rounded-xl"
                    width="1000"
                    flat
                >
                    <v-card-title
                        class="d-flex white--text pb-4 px-0"
                    >
                        <div 
                            class="font-weight-bold primary--text  pl-4"
                        >
                            <span>
                                {{ academicYear }} Term {{ term }} Mark Sheet
                            </span>
                            <span class="font-weight-regular ">
                                <v-chip color="blue lighten-3" class="mx-3 primary--text" small>
                                    {{ lessonSelected.subject_title }}
                                </v-chip>
                            </span>
                        </div>
    
                        
                        <v-spacer></v-spacer>
                        <v-btn
                            class="mr-3"
                            color="primary"
                            @click="displayMarkSheetMenu"
                            rounded
                        >Next Subject Class</v-btn>
                        <!-- <v-btn
                            icon               
                            color="red"
                            @click="displayMarkSheetMenu"
                            class="mr-3"
                        >
                            <v-icon>mdi-window-close</v-icon>
                        </v-btn>             -->
                    </v-card-title>
    
                    
                    <v-row class="" >
                        <v-col class="py-0">
                            <!-- <Header
                                @filter-students-by-class="filterStudentsByClass"
                            /> -->
                            
                            <MarkSheetTable
                                :selectedClasses="selectedClasses"
                                :coCurricularStudents="coCurricularStudents"
                                :coCurricularClubs="coCurricularClubs"
                                @closeMarkSheet="closeMarkSheet"
                            />
                        </v-col>
                    </v-row>
                    
                    <v-overlay
                        absolute
                        :value="overlay"                    
                        color="grey lighten-5"
                        opacity="0.9"
                        class="pa-5"
                    >                    
                        
                        <Lesson 
                            v-if="displayLessons"
                            @cocurricular="displayClassesCocurricular"
                        />
                        
                        <Teacher 
                            v-if="displayTeachers"
                        />
    
                        <MarkSheetCocurricular 
                            :expand="displayCocurricularClasses"
                            @close-classes="closeCocurricularClasses"
                            @display-cocurricular-marksheet="displayCocurricularMarksheet"
                        />
    
                        <v-progress-circular 
                            transition="fade-transition" 
                            indeterminate 
                            size="64"
                            v-if="loading"
                            color="primary"
                        ></v-progress-circular> 
                    </v-overlay>
                </v-card>
            </v-col>
            
        </v-row>    
    </v-container> 
</template>

<script>
// import Header from './MarkSheetHeader'
import Lesson from './MarkSheetLesson'
import Teacher from './MarkSheetTeacher'
import MarkSheetTable from './MarkSheetTable'
import { mapGetters, mapMutations } from 'vuex'
import MarkSheetCocurricular from './MarkSheetCocurricular'
export default {
    name: 'MarkSheet',

    created () {
        this.initialize();
    },
  
    components: {
        // Header,
        Lesson,
        Teacher,
        MarkSheetTable,
        MarkSheetCocurricular,
    },

    computed: {
        ...mapGetters({            
            overlay: 'markSheet/getMarkSheetOverlay',
            loading: 'markSheet/getMarkSheetLoading',
            totalStudents: 'markSheet/getTotalStudents',
            admin: 'auth/getAdmin',
            displayLessons: 'markSheet/getDisplayLessons',
            displayTeachers: 'markSheet/getDisplayTeachers',
            lessonSelected: 'markSheet/getLessonSelected',
            academicYear: 'app/getAcademicYear',
            term: 'app/getTerm',
            editTermReport: 'auth/getEditTermReport',
        }), 
    },
    
    watch: {
       //
    },

    data: () => ({
        userTimetable: [],
        selectedClasses: [],
        displayCocurricularClasses: false,
        coCurricularStudents: [],
        coCurricularClubs: [],
    }),

    methods: {
        ...mapMutations({
            setOverlay: 'markSheet/setMarkSheetOverlay',
            setMarkSheetLoading: 'markSheet/setMarkSheetLoading',
            setDisplayLessons: 'markSheet/setDisplayLessons',
            setDisplayTeachers: 'markSheet/setDisplayTeachers',                       
        }),

        initialize () {
            this.displayMarkSheetMenu()               
        },
                      
        displayMarkSheetMenu () {
            this.setOverlay(true);
            if(this.admin || this.editTermReport){
                this.setDisplayLessons(false);
                this.setDisplayTeachers(true);                
            }
            else {
                this.setDisplayLessons(true);
                this.setDisplayTeachers(false);
            }           
        },

        filterStudentsByClass (selectedClasses) {
            this.selectedClasses = selectedClasses
        },

        displayClassesCocurricular () {
            this.displayCocurricularClasses = true;
        },

        closeCocurricularClasses() {
            this.displayCocurricularClasses = false;
        },

        displayCocurricularMarksheet (dataStudents, dataClubs) {
            this.coCurricularStudents = dataStudents,
            this.coCurricularClubs = dataClubs
            this.setOverlay(false);
        },

        closeMarkSheet (){
            this.displayMarkSheetMenu();
        }
       
    }
}
</script>

<style scoped>
   
</style>